import React from "react";
import styled from "styled-components";
import { ArrowLeft } from "lucide-react";

const StyledBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  padding: 8px 12px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  color: #3b82f6;
  transition: all 0.2s ease;
  margin-bottom: 16px;

  &:hover {
    background: rgba(59, 130, 246, 0.1);
    color: #2563eb;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
    background: rgba(59, 130, 246, 0.15);
  }

  svg {
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(-2px);
  }

  @media (max-width: 1024px) {
    padding: 8px 12px;
    font-size: 16px;
    border-radius: 14px;
    margin-bottom: 16px;
  }
`;

const BackButton = ({ onClick, children = "Back", size = 18, ...props }) => {
  return (
    <StyledBackButton onClick={onClick} {...props}>
      <ArrowLeft size={size} />
      {children}
    </StyledBackButton>
  );
};

export default BackButton;
